import { useState } from "react";
import { FiUploadCloud } from "react-icons/fi";
import "../styles.css";
import ImagePicker from "../../../component/image-picker";
import { Button } from "antd";
import { onImgErrorFallback } from "../../../utils/mediaFallback";
function BannerImage(props: any) {
  const [show, setShow] = useState<any>(false);

  if (props?.disabled) {
    return props?.image ? (
      <div style={{ marginBottom: 16 }}>
        <img
          src={props?.image}
          style={{ maxWidth: "100%", borderRadius: 4, display: "block" }}
          onError={onImgErrorFallback}
        />
      </div>
    ) : (
      <p style={{ color: "grey", fontSize: 12, marginBottom: 16 }}>
        No image set
      </p>
    );
  }

  return (
    <>
      <div>
        {props?.image ? (
          <div className="quiz-BannerImage2">
            <img
              src={props?.image}
              className="quiz-BannerImage3"
              onError={onImgErrorFallback}
            />
            <div className="quiz-BannerImage4">
              <div className="quiz-txt1">{props?.image}</div>
              <div>
                <Button
                  size="small"
                  danger
                  onClick={() => props?.onChagne(null)}
                >
                  Remove
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="quiz-BannerImage"
            onClick={() => setShow(!show)}
          >
            <FiUploadCloud size={30} color="grey" />
            <div>Select Image</div>
          </div>
        )}
      </div>
      {show ? (
        <ImagePicker
          visible={show}
          close={() => setShow(false)}
          onSubmit={(val: any) => props?.onChagne(val?.image_url)}
        />
      ) : null}
    </>
  );
}

export default BannerImage;
